module.exports = __webpack_public_path__ + "img/16581264_L.79054ceb.png";